import $ from 'jquery';
import { FireComponent } from '@base';

export class ContactInfo extends FireComponent {
  constructor(id) {
    super(id);
  }

  get elements() {
    return {
      $item: this.$component.find('[data-contact-info-item]'),
    };
  }

  _ada() {
    [...this.elements.$item].map((item, index) => {
      let anchor = item.querySelector('a');
      if (anchor) {
        if (anchor.getAttribute('href').startsWith('tel')) {
          anchor.setAttribute('aria-label', `Call us at ${anchor.innerText}`);
        } else if (anchor.getAttribute('href').startsWith('mailto')) {
          anchor.setAttribute('aria-label', `Email us at ${anchor.innerText}`);
        }
      }
    });
  }

  init() {
    if (this.componentExists) {
      this._ada();
    }
  }
}
